import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { AuthenticationResponseModel } from '../model/authentication-response.model';
import { version } from '../../../../environments/version';

// CL-618/CL-621 follow-up: referring-doctor equivalent of PatientAutoLoginComponent, for the
// "/rl/:t" magic link emailed on a "Send Link to Doctor Only" TDOx send - see
// JwtAuthenticationService.GenerateReferrerDocumentToken (tdoxc-backend) and
// AuthenticationService.autoLoginReferrer above.
@Component({
  standalone: false,
  selector: 'app-referrer-auto-login',
  templateUrl: 'referrer-auto-login.component.html',
  styleUrls: ['referrer-auto-login.component.scss']
})
export class ReferrerAutoLoginComponent implements OnInit {
  public outStr = 'Attempting auto login...';
  // Drives the heading shown in the template - "Referrer Login" while attempting/succeeding,
  // "Link Expired" on failure, so a failed magic link doesn't read as a normal login prompt.
  public failed = false;
  isLoading: boolean = false;
  token: string;
  logoUrl: string = '';
  appVersion: string = version;
  mounted: boolean = false;
  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly authService: AuthenticationService,
    private readonly cdr: ChangeDetectorRef,
  ) { }

  ngOnInit() {
    this.isLoading = false;
    this.token = this.route.snapshot.paramMap.get('t');

    // Trigger entrance animation after view init
    setTimeout(() => {
      this.mounted = true;
    }, 50);

    this.authService.getLocationLogo().subscribe({
      next: (logoData: any) => {
        this.logoUrl = logoData;
      },
      error: (error) => {
        console.error('error getting location logo: ' + error.message);
        this.logoUrl = '';
      }
    });

    if (this.token) {
      this.isLoading = true;
      this.authService.autoLoginReferrer(this.token).subscribe({
        next: (res: AuthenticationResponseModel) => {
          if (res.isSuccess) {
            localStorage.setItem('TDOauthToken', res.token);

            // CL-618/CL-621 follow-up: a "Send Link to Doctor Only" magic-link email carries
            // these so the doctor lands directly on the specific document's viewer instead of
            // just the generic referrer portal home - see ReferrerPortalHomeComponent.init,
            // which reads them back out on the other side of this navigation.
            const appointmentId = this.route.snapshot.queryParamMap.get('appointmentId');
            const documentId = this.route.snapshot.queryParamMap.get('documentId');

            this.router.navigate(['/referrerportal/home'], appointmentId && documentId
              ? { queryParams: { appointmentId, documentId } }
              : undefined);
          }
          else {
            this.isLoading = false;
            this.failed = true;
            this.outStr = 'This link has expired or has already been used. Please contact the practice to request a new link.';
          }
        },
        error: (error) => {
          console.error('auto login error:', error);
          this.isLoading = false;
          this.failed = true;
          this.outStr = 'This link has expired or has already been used. Please contact the practice to request a new link.';
        },
        complete: () => {
          this.cdr.detectChanges();
        }
      });
    }
  }
}
